module.exports = __webpack_public_path__ + "9e84e53cb2c1853f1d126b600e8f481b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fin-risk-oil-chart.jpg
// module id = 580
// module chunks = 0